import React from 'react';
import type { MusicProps } from './EventHero';

type Props = {
    isCreatorCollectionsLinkMobile?: boolean;
    eventNameTruncated: string;
} & MusicProps;

export const MusicEventBlock = ({
    isCreatorCollectionsLinkMobile = false,
    eventNameTruncated,
    hasPresenter,
    presenter,
    hasAgeRestriction,
    ageRestriction,
}: Props) => {
    return (
        <div className="g-group">
            <div className="g-vertical-group g-cell-1-1">
                <div className="g-cell g-cell-1-1 g-cell--no-gutters">
                    <h1 className="text-body-large">{eventNameTruncated}</h1>
                    <meta content={eventNameTruncated} />
                </div>
                <div
                    id={`listings-root__link-to-creator-collections${
                        isCreatorCollectionsLinkMobile ? '--mobile' : ''
                    }`}
                    className="g-cell g-cell-1-1 g-cell--no-gutters l-pad-top-1 l-pad-bot-2"
                ></div>
                {hasPresenter && (
                    <div className="g-cell g-cell-1-1 g-cell--no-gutters">
                        <span className="text-body-medium text-body--faint">
                            {presenter}
                        </span>
                    </div>
                )}
                {hasAgeRestriction && (
                    <div className="g-cell g-cell-1-1 g-cell--no-gutters">
                        <span className="text-body-medium text-body--faint">
                            {ageRestriction}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};
